import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">{aboutInfo.title}</h2>
            {aboutInfo.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 max-w-xl">
                {p}
              </p>
            ))}
          </div>

          <div className="flex-shrink-0 w-full max-w-md lg:max-w-lg">
            <div className="aspect-[3/2] rounded-2xl overflow-hidden">
              <img
                src={aboutInfo.image}
                alt="吃瓜视频团队工作场景"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}